// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1TQob","tabPanel":"Tabs_tabPanel__Ybtpz","spaceFiller":"Tabs_spaceFiller__4PyIb","leftBorder":"Tabs_leftBorder__1BOs7"};